import * as ActionTypes from '../constants/ActionTypes';

const INITIAL_STATE = {
	loggedIn: false,
	id: '',
	authType: '',
	userName: '',
};

const signUpData = (state, payload) => ({
	...state,
	loggedIn: true,
	id: payload.data.userId,
	authType: payload.authType,
	userName: payload.data.userName,
});

const signInData = (state, payload) => ({
	...state,
	loggedIn: true,
	id: payload.data.userId,
	authType: payload.authType,
	userName: payload.data.userName,
});

export default (state = INITIAL_STATE, { type, payload }) => {
	switch (type) {
		case ActionTypes.SIGN_UP_USER_SUCCESS:
			return signUpData(state, payload);
		case ActionTypes.SIGN_IN_USER_SUCCESS:
			return signInData(state, payload);
		case ActionTypes.RESET_AUTH_DATA:
			return INITIAL_STATE;
		default:
			return state;
	}
};
